import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d5798292"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "orders-view" }
const _hoisted_2 = { class: "orders-view__menu" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OrdersNavigationPanel = _resolveComponent("OrdersNavigationPanel")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_OrdersNavigationPanel)
    ]),
    _createVNode(_component_router_view)
  ]))
}